<template#action>
  <div class="flex justify-center my-2">
    <aha-button variant="primary" @click="handleCopyButtonClick()" :disabled="!selectedPresentationId">
      <span>
        <span>{{ $i18nPresenter.t('Copy') }}</span>
        <span
          v-if="isSlideCopying"
          class="ml-1 loading-spinner"
        />
      </span>
    </aha-button>
  </div>
</template>

<script>
export default {
  props: {
    selectedPresentationId: {
      type: Number,
      default: null,
    },
    isSlideCopying: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    handleCopyButtonClick() {
      this.$emit('handleCopyButtonClick')
    },
  }
}
</script>
